import { Component, inject, Inject } from '@angular/core';
import { ModalComponent } from '../modals/modal/modal.component';
import { TranslatePipe } from '../../pipes/translate/translate.pipe';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { IconComponent } from '../ui/icon/icon.component';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { Router } from '@angular/router';

@Component({
  selector: 'bizz-pwa-refresh-token-expired-modal',
  standalone: true,
  imports: [ModalComponent, TranslatePipe, IconComponent],
  templateUrl: './pwa-refresh-token-expired-modal.component.html',
  styleUrl: './pwa-refresh-token-expired-modal.component.scss'
})
export class PwaRefreshTokenExpiredModalComponent {
  public pwaService = inject(PwaService);
  private router = inject(Router);
  public constructor(public dialogRef: DialogRef, @Inject(DIALOG_DATA) public data: any) { }

  public stayOffline(): void {
    this.router.navigate(['/']);
    this.dialogRef.close();
  }

  public login(): void {
    this.dialogRef.close(true);
  }
}
